import { render, staticRenderFns } from "./TopTravelItem.vue?vue&type=template&id=2a049d60&scoped=true&"
import script from "./TopTravelItem.vue?vue&type=script&lang=js&"
export * from "./TopTravelItem.vue?vue&type=script&lang=js&"
import style0 from "./TopTravelItem.vue?vue&type=style&index=0&id=2a049d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a049d60",
  null
  
)

export default component.exports